module.exports = __webpack_public_path__ + "img/PG.3e5a587d.png";